import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Checklist: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_28719)'>
        <path
          d='M19.9843 22.9492H4.01652C3.63364 22.9492 3.32227 22.6309 3.32227 22.2395V1.6589C3.32227 1.26751 3.63364 0.949219 4.01652 0.949219H19.9843C20.3671 0.949219 20.6785 1.26751 20.6785 1.6589V22.2395C20.6785 22.6309 20.3671 22.9492 19.9843 22.9492ZM4.01652 1.6589V22.2395H19.9843V1.6589H4.01652Z'
          fill='url(#paint0_linear_12280_28719)'
          stroke='url(#paint1_linear_12280_28719)'
          strokeWidth='0.5'
        />
        <path
          d='M10.4791 7.6114H6.13033C5.93872 7.6114 5.7832 7.45243 5.7832 7.25656V3.0189C5.7832 2.82303 5.93872 2.66406 6.13033 2.66406H10.4791C10.6707 2.66406 10.8262 2.82303 10.8262 3.0189V7.25656C10.8262 7.45243 10.6707 7.6114 10.4791 7.6114ZM6.47745 6.90172H10.132V3.37374H6.47745V6.90172Z'
          fill='url(#paint2_linear_12280_28719)'
          stroke='url(#paint3_linear_12280_28719)'
          strokeWidth='0.5'
        />
        <path
          d='M8.17298 6.36661C8.10529 6.36661 8.03743 6.34656 7.97789 6.30522L7.2984 5.83293C7.13993 5.72276 7.0988 5.50205 7.20658 5.33988C7.31454 5.17808 7.53028 5.13638 7.68891 5.24603L8.12733 5.55101L9.28048 4.338C9.4143 4.1973 9.63385 4.19447 9.77132 4.33072C9.90878 4.46751 9.91207 4.69195 9.77843 4.83247L8.42221 6.25909C8.3547 6.33006 8.2641 6.36661 8.17298 6.36661Z'
          fill='url(#paint4_linear_12280_28719)'
          stroke='url(#paint5_linear_12280_28719)'
          strokeWidth='0.5'
        />
        <path
          d='M17.8712 4.68624H12.646C12.4543 4.68624 12.2988 4.52727 12.2988 4.3314C12.2988 4.13553 12.4543 3.97656 12.646 3.97656H17.8712C18.0628 3.97656 18.2183 4.13553 18.2183 4.3314C18.2183 4.52727 18.063 4.68624 17.8712 4.68624Z'
          fill='url(#paint6_linear_12280_28719)'
          stroke='url(#paint7_linear_12280_28719)'
          strokeWidth='0.5'
        />
        <path
          d='M17.8712 6.49093H12.646C12.4543 6.49093 12.2988 6.33196 12.2988 6.13609C12.2988 5.94022 12.4543 5.78125 12.646 5.78125H17.8712C18.0628 5.78125 18.2183 5.94022 18.2183 6.13609C18.2183 6.33196 18.063 6.49093 17.8712 6.49093Z'
          fill='url(#paint8_linear_12280_28719)'
          stroke='url(#paint9_linear_12280_28719)'
          strokeWidth='0.5'
        />
        <path
          d='M10.4791 14.4159H6.13033C5.93872 14.4159 5.7832 14.2569 5.7832 14.0611V9.82359C5.7832 9.62772 5.93872 9.46875 6.13033 9.46875H10.4791C10.6707 9.46875 10.8262 9.62772 10.8262 9.82359V14.0613C10.8262 14.2571 10.6707 14.4159 10.4791 14.4159ZM6.47745 13.7062H10.132V10.1784H6.47745V13.7062Z'
          fill='url(#paint10_linear_12280_28719)'
          stroke='url(#paint11_linear_12280_28719)'
          strokeWidth='0.5'
        />
        <path
          d='M8.17298 13.187C8.10529 13.187 8.03743 13.1669 7.97789 13.1256L7.2984 12.6533C7.13993 12.5431 7.0988 12.3224 7.20658 12.1603C7.31454 11.9986 7.53028 11.9566 7.68891 12.0664L8.12733 12.3714L9.28048 11.1584C9.4143 11.0177 9.63385 11.0147 9.77132 11.1511C9.90878 11.2879 9.91207 11.5123 9.77843 11.6528L8.42221 13.0795C8.3547 13.1504 8.2641 13.187 8.17298 13.187Z'
          fill='url(#paint12_linear_12280_28719)'
          stroke='url(#paint13_linear_12280_28719)'
          strokeWidth='0.5'
        />
        <path
          d='M17.8712 11.5026H12.646C12.4543 11.5026 12.2988 11.3437 12.2988 11.1478C12.2988 10.9519 12.4543 10.793 12.646 10.793H17.8712C18.0628 10.793 18.2183 10.9519 18.2183 11.1478C18.2183 11.3437 18.063 11.5026 17.8712 11.5026Z'
          fill='url(#paint14_linear_12280_28719)'
          stroke='url(#paint15_linear_12280_28719)'
          strokeWidth='0.5'
        />
        <path
          d='M17.8712 13.2995H12.646C12.4543 13.2995 12.2988 13.1406 12.2988 12.9447C12.2988 12.7488 12.4543 12.5898 12.646 12.5898H17.8712C18.0628 12.5898 18.2183 12.7488 18.2183 12.9447C18.2183 13.1406 18.063 13.2995 17.8712 13.2995Z'
          fill='url(#paint16_linear_12280_28719)'
          stroke='url(#paint17_linear_12280_28719)'
          strokeWidth='0.5'
        />
        <path
          d='M10.4791 21.2403H6.13033C5.93872 21.2403 5.7832 21.0813 5.7832 20.8855V16.6478C5.7832 16.4519 5.93872 16.293 6.13033 16.293H10.4791C10.6707 16.293 10.8262 16.4519 10.8262 16.6478V20.8855C10.8262 21.0813 10.6707 21.2403 10.4791 21.2403ZM6.47745 20.5306H10.132V17.0026H6.47745V20.5306Z'
          fill='url(#paint18_linear_12280_28719)'
          stroke='url(#paint19_linear_12280_28719)'
          strokeWidth='0.5'
        />
        <path
          d='M8.17298 19.9956C8.10529 19.9956 8.03743 19.9755 7.97789 19.9342L7.2984 19.4619C7.13993 19.3517 7.0988 19.131 7.20658 18.9689C7.31454 18.8072 7.53028 18.7652 7.68891 18.875L8.12733 19.18L9.28048 17.967C9.4143 17.8263 9.63385 17.8233 9.77132 17.9597C9.90878 18.0965 9.91207 18.3209 9.77843 18.4614L8.42221 19.8881C8.3547 19.959 8.2641 19.9956 8.17298 19.9956Z'
          fill='url(#paint20_linear_12280_28719)'
          stroke='url(#paint21_linear_12280_28719)'
          strokeWidth='0.5'
        />
        <path
          d='M17.8712 18.323H12.646C12.4543 18.323 12.2988 18.164 12.2988 17.9681C12.2988 17.7722 12.4543 17.6133 12.646 17.6133H17.8712C18.0628 17.6133 18.2183 17.7722 18.2183 17.9681C18.2183 18.164 18.063 18.323 17.8712 18.323Z'
          fill='url(#paint22_linear_12280_28719)'
          stroke='url(#paint23_linear_12280_28719)'
          strokeWidth='0.5'
        />
        <path
          d='M17.8712 20.1198H12.646C12.4543 20.1198 12.2988 19.9609 12.2988 19.765C12.2988 19.5691 12.4543 19.4102 12.646 19.4102H17.8712C18.0628 19.4102 18.2183 19.5691 18.2183 19.765C18.2183 19.9609 18.063 20.1198 17.8712 20.1198Z'
          fill='url(#paint24_linear_12280_28719)'
          stroke='url(#paint25_linear_12280_28719)'
          strokeWidth='0.5'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_28719'
          x1='6.91635'
          y1='2.44937'
          x2='18.2534'
          y2='20.3757'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_28719'
          x1='6.91635'
          y1='2.44937'
          x2='18.2534'
          y2='20.3757'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint2_linear_12280_28719'
          x1='6.8275'
          y1='3.00142'
          x2='9.05596'
          y2='7.55426'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint3_linear_12280_28719'
          x1='6.8275'
          y1='3.00142'
          x2='9.05596'
          y2='7.55426'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint4_linear_12280_28719'
          x1='7.71182'
          y1='4.37613'
          x2='8.5373'
          y2='6.49064'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint5_linear_12280_28719'
          x1='7.71182'
          y1='4.37613'
          x2='8.5373'
          y2='6.49064'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint6_linear_12280_28719'
          x1='13.5246'
          y1='4.02495'
          x2='13.5729'
          y2='4.83162'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint7_linear_12280_28719'
          x1='13.5246'
          y1='4.02495'
          x2='13.5729'
          y2='4.83162'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint8_linear_12280_28719'
          x1='13.5246'
          y1='5.82964'
          x2='13.5729'
          y2='6.63631'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint9_linear_12280_28719'
          x1='13.5246'
          y1='5.82964'
          x2='13.5729'
          y2='6.63631'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint10_linear_12280_28719'
          x1='6.8275'
          y1='9.80609'
          x2='9.05583'
          y2='14.3588'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint11_linear_12280_28719'
          x1='6.8275'
          y1='9.80609'
          x2='9.05583'
          y2='14.3588'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint12_linear_12280_28719'
          x1='7.71182'
          y1='11.1964'
          x2='8.53735'
          y2='13.311'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint13_linear_12280_28719'
          x1='7.71182'
          y1='11.1964'
          x2='8.53735'
          y2='13.311'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint14_linear_12280_28719'
          x1='13.5246'
          y1='10.8414'
          x2='13.5729'
          y2='11.648'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint15_linear_12280_28719'
          x1='13.5246'
          y1='10.8414'
          x2='13.5729'
          y2='11.648'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint16_linear_12280_28719'
          x1='13.5246'
          y1='12.6382'
          x2='13.5729'
          y2='13.4449'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint17_linear_12280_28719'
          x1='13.5246'
          y1='12.6382'
          x2='13.5729'
          y2='13.4449'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint18_linear_12280_28719'
          x1='6.8275'
          y1='16.6303'
          x2='9.05596'
          y2='21.1832'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint19_linear_12280_28719'
          x1='6.8275'
          y1='16.6303'
          x2='9.05596'
          y2='21.1832'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint20_linear_12280_28719'
          x1='7.71182'
          y1='18.005'
          x2='8.53735'
          y2='20.1196'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint21_linear_12280_28719'
          x1='7.71182'
          y1='18.005'
          x2='8.53735'
          y2='20.1196'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint22_linear_12280_28719'
          x1='13.5246'
          y1='17.6617'
          x2='13.5729'
          y2='18.4683'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint23_linear_12280_28719'
          x1='13.5246'
          y1='17.6617'
          x2='13.5729'
          y2='18.4683'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint24_linear_12280_28719'
          x1='13.5246'
          y1='19.4585'
          x2='13.5729'
          y2='20.2652'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint25_linear_12280_28719'
          x1='13.5246'
          y1='19.4585'
          x2='13.5729'
          y2='20.2652'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_28719'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Checklist;
